module.exports = __webpack_public_path__ + "static/media/icon-search-properties.503619d6.svg";